import { GrFormNext, GrFormPrevious } from "react-icons/gr";
import ReactPaginate from "react-paginate";
import { useSearchParams } from "react-router-dom";

interface Props {
  reportsCount: number;
  reportsAnswers: any[];
  report: any;
}

export default function ReportPagination({
  reportsCount,
  reportsAnswers,
  report,
}: Props) {
  const [searchParams, setSearchParams] = useSearchParams();
  const itemsPerPage = Number(searchParams.get("itemsPerPage") || "25");
  const page = Number(searchParams.get("page")) || 1;

  return (
    itemsPerPage != 0 &&
    reportsAnswers.length > 0 &&
    !report?.report_type?.includes("nested") &&
    report?.report_title && (
      <ReactPaginate
        className="pagination_table"
        containerClassName={"pagination"}
        activeClassName={"active"}
        pageClassName={"page-item"}
        forcePage={page - 1}
        onPageChange={(event: any) => {
          setSearchParams((prev) => {
            prev.set("page", (event.selected + 1).toString());
            return prev;
          });
        }}
        breakLabel="..."
        pageCount={Math.ceil(reportsCount / (itemsPerPage == 0 ? reportsCount : itemsPerPage))}
        previousLabel={
          page == 1 ? null : (
            <div
              style={{
                backgroundColor: "#B8C1CC",
                width: "36px",
                height: "36px",
              }}
              className="flex items-center justify-center rounded-full text-white"
            >
              <GrFormPrevious size={28} />
            </div>
          )
        }
        nextLabel={
          page == Math.ceil(reportsCount / (itemsPerPage == 0 ? reportsCount : itemsPerPage)) ? null : (
            <div
              style={{
                backgroundColor: "#B8C1CC",
                width: "36px",
                height: "36px",
              }}
              className="flex items-center justify-center rounded-full text-white"
            >
              <GrFormNext size={28} />
            </div>
          )
        }
      />
    )
  );
}
